/* ==================== PAGE PUB ==================== */

const PUB = window.location.hash === "#pub";

if(PUB) {
  for(let element of document.querySelectorAll('.Pub')) {
    element.classList.remove('Pub');
  }
  for(let element of document.querySelectorAll('.NotPub')) {
    element.remove();
  }
}

/* ==================== UTILS ==================== */

const size = {
  width: window.innerWidth,
  height: window.innerHeight
}

const removeClassNameToCollection = (collection, className) => {
  if(typeof collection === 'string') {
    for(let elt of document.querySelectorAll(collection)) {
      elt.classList.remove(classNamea);
    }
  } else {
    for(let elt of collection) {
      elt.classList.remove(className);
    }
  }
}

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    entry.target.classList.toggle('visible', entry.isIntersecting);
    if (entry.isIntersecting) observer.unobserve(entry.target);
  });
}, {
  threshold: 1
});

// Fonction pour vérifier si l'utilisateur est sur iOS
function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

// Fonction pour vérifier si l'utilisateur est sur Android
function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

/* ==================== FLYING BUTTON ==================== */

const handleFlyingButton = () => {

  const button = document.querySelector('.flying-button');
  const url = window.location.href;

  if (url.includes("#pub")) {
    button.classList.add('active');
  }

}

handleFlyingButton();

/* ==================== SMOOTH SCROLL ==================== */

gsap.registerPlugin(ScrollTrigger);

/* ==================== MAIN HEADER ==================== */

class MainHeader extends HTMLElement {

  constructor() {
    super();
    this.active = false;
    this.mobileOpen = false;
    this.burger = this.querySelector('.main-header-burger');
    this.mobileMenu = this.querySelector('.main-header-mobile');
    this.init();
  }

  init() {
    this.setEventListeners();
  }

  setEventListeners() {

    this.burger.addEventListener('click', () => {
      if(!this.mobileOpen) {
        this.mobileOpen = true;
        const timeline = gsap.timeline();
        timeline.to(this.mobileMenu, { y: '-20vh', duration: 1.5, ease: 'elastic.out(1, .75)' }, 0);
        timeline.to(this.burger, { backgroundColor: '#fff', duration: .5 }, 0);
        timeline.to(this.burger.querySelectorAll('div'), { backgroundColor: '#000', duration: .25 }, 0);
        timeline.to(this.burger.querySelector('div:nth-child(1)'), { x: 2, rotate: 45, duration: .25 }, 0);
        timeline.to(this.burger.querySelector('div:nth-child(2)'), { opacity: 0, duration: .25 }, 0);
        timeline.to(this.burger.querySelector('div:nth-child(3)'), { x: 2, rotate: -45, duration: .25 }, 0);
      } else {
        this.mobileOpen = false;
        const timeline = gsap.timeline();
        timeline.to(this.mobileMenu, { y: '-120vh', duration: 1, ease: 'elastic.out(1, .75)' }, 0);
        timeline.to(this.burger, { backgroundColor: 'rgba(255, 255, 255, 0)', duration: .25 }, 0);
        timeline.to(this.burger.querySelectorAll('div'), { backgroundColor: '#fff', duration: .25 }, 0);
        timeline.to(this.burger.querySelector('div:nth-child(1)'), { x: 0, rotate: 0, duration: .25 }, 0);
        timeline.to(this.burger.querySelector('div:nth-child(2)'), { opacity: 1, duration: .25 }, 0);
        timeline.to(this.burger.querySelector('div:nth-child(3)'), { x: 0, rotate: 0, duration: .25 }, 0);
      }
    })
    
    window.addEventListener('scroll', () => {
      if(window.scrollY > 50) {
        if(!this.classList.contains('active')) this.classList.add('active');
        // if(!this.active) {
        //   this.active = true;
        //   this.setScrollMenuAnimation();
        // }
      } else {
        if(this.classList.contains('active')) this.classList.remove('active');
        // if(this.active) {
        //   this.active = false;
        //   this.setInitialMenuAnimation();
        // }
      }
    });
  }

  setInitialMenuAnimation() {
    const timeline = gsap.timeline();
    timeline.to(this.querySelector('.main-header-wrap'), { borderBottom: '1px solid rgba(255, 255, 255, 0)', duration: 1, ease: 'power2.inOut' }, 0);
    timeline.to(this.querySelector('.main-header-wrap .background'), { width: 600, height: '50%', borderRadius: 50, duration: 1, ease: 'power2.inOut' }, 0);
    timeline.to(this.querySelector('.padding'), { padding: '3em 5%', duration: 1, ease: 'power2.inOut' }, 0);
  }

  setScrollMenuAnimation() {
    const timeline = gsap.timeline();
    timeline.to(this.querySelector('.main-header-wrap'), { borderBottom: '1px solid rgba(255, 255, 255, .1)', duration: 1, ease: 'power2.inOut' }, 0);
    timeline.to(this.querySelector('.main-header-wrap .background'), { width: '100vw', height: '100%', borderRadius: 0, duration: 1, ease: 'power2.inOut' }, 0);
    timeline.to(this.querySelector('.padding'), { padding: '1em 5%', duration: 1, ease: 'power2.inOut' }, 0);
  }

}

customElements.define('main-header', MainHeader);

/* ==================== SLIDER ==================== */

class CustomSlider extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }
  
  init() {
    this.type = this.dataset.type || 'loop';
    this.perPage = parseInt(this.dataset.perpage) || 1;
    this.arrows = this.dataset.arrows || false;
    this.pagination = this.dataset.pagination || false;
    this.setSlider();
  }
  
  setSlider() {
    const slider = new Splide(this, {
      type: 'loop',
      perPage: this.perPage,
      arrows: false,
      pagination: false
    });
    slider.mount();
  }
  
}

customElements.define('custom-slider', CustomSlider);

/* ==================== SECTION : LOGO SLIDER ==================== */

class LogoSlider extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }
  
  init() {
    this.setSlider();
  }
  
  setSlider() {
    const slider = new Splide(this, {
      type: 'loop',
      perPage: 7,
      arrows: false,
      pagination: false,
      autoscroll: {
        speed: 1
      },
      breakpoints: {
        400: {
          perPage: 2,
          padding: 50
        },
        640: {
          perPage: 3
        },
        728: {
          perpage: 4
        },
        1024: {
          perpage: 5
        }
      }
    });
    slider.mount( window.splide.Extensions );
  }
  
}

customElements.define('logo-slider', LogoSlider);

/* ==================== SECTION : HOME HERO ==================== */

class HomeHero extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init() {
    
    this.mobile = window.innerWidth <= 640;

    this.setEventListeners();

    if(this.mobile) {
      this.setMobileAnimation();
    } else {
      this.setLoadingAnimation();
      this.setScrollAnimation();
    }

  }

  setEventListeners() {
    window.addEventListener('resize', () => {
      const currentMobile = window.innerWidth <= 640;
      if (this.mobile !== currentMobile) {
        this.mobile = currentMobile;
        this.init();
      }
    });
  }

  setLoadingAnimation() {
    const spotlight = this.querySelector('.spotlight')
    const timeline = gsap.timeline();
    timeline.set(spotlight, { opacity: 0 });
    timeline.to(spotlight, { opacity: 1, duration: .1, delay: .5 });
    timeline.to(spotlight, { opacity: 0, duration: .1 });
    timeline.to(spotlight, { opacity: 1, duration: .12 });
    timeline.to(spotlight, { opacity: 0, duration: .15 });
    timeline.to(spotlight, { opacity: 1, duration: .25 });
  }

  setMobileAnimation() {

    const timeline = gsap.timeline();
    timeline.set('.home-hero .card', { opacity: 0 });

    timeline.fromTo('.home-hero .box.center', { scale: 2 }, { scale: 1, duration: 1, ease: 'bounce' }, .5);
    timeline.fromTo('.home-hero .box.center', { opacity: 0 }, { opacity: 1, duration: .5, ease: 'power2.inOut' }, .5);

    timeline.to('.home-hero .card', { opacity: 1, duration: 0, ease: 'power2.inOut' }, 1);
    
    timeline.to('.home-hero .card.left-1', { x: -200, y: -50, rotation: -44, duration: 1, ease: 'power2.inOut' }, 1);
    timeline.to('.home-hero .card.left-2', { x: -100, y: 100, rotation: -22, duration: 1, ease: 'power2.inOut' }, 1);
    timeline.to('.home-hero .card.left-3', { x: -100, y: -140, rotation: -20, duration: 1, ease: 'power2.inOut' }, 1);

    timeline.to('.home-hero .card.right-1', { x: 200, y: -0, rotation: -20, duration: 1, ease: 'power2.inOut' }, 1);
    timeline.to('.home-hero .card.right-2', { x: 100, y: -120, rotation: 20, duration: 1, ease: 'power2.inOut' }, 1);
    timeline.to('.home-hero .card.right-3', { x: 100, y: 100, rotation: 22, duration: 1, ease: 'power2.inOut' }, 1);
    
  }

  setScrollAnimation() {

    const timeline = gsap.timeline();

    timeline.fromTo('.home-hero .box.center', { y: 200 }, { y: -100, duration: 1, ease: Power0.easeNone }, 0);

    timeline.fromTo('.home-hero .card.left-1', { x: 100 }, { x: -50, y: 0, rotation: -10, duration: 1, ease: Power0.easeNone }, 0);
    timeline.fromTo('.home-hero .card.left-2', { x: 200 }, { x: -65, y: 100, rotation: -20, duration: 1, ease: Power0.easeNone }, 0);
    timeline.fromTo('.home-hero .card.left-3', { x: 300 }, { x: -80, y: 250, rotation: -35, duration: 1, ease: Power0.easeNone }, 0);

    timeline.fromTo('.home-hero .card.right-1', { x: -100 }, { x: 50, y: 0, rotation: 10, duration: 1, ease: Power0.easeNone }, 0);
    timeline.fromTo('.home-hero .card.right-2', { x: -200 }, { x: 65, y: 100, rotation: 20, duration: 1, ease: Power0.easeNone }, 0);
    timeline.fromTo('.home-hero .card.right-3', { x: -300 }, { x: 80, y: 250, rotation: 35, duration: 1, ease: Power0.easeNone }, 0);

    // timeline.fromTo('.home-hero .rounded-div-wrap', { height: 0 }, { height: 150, duration: 1, ease: Power0.easeNone }, 0);

    ScrollTrigger.create({
      trigger: this,
      animation: timeline,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true
    });
    
  }
}

customElements.define('home-hero', HomeHero);

/* ==================== BOTTOM CTA WRAP ==================== */

class BottomCTA extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init() {
    this.visible = true;
    this.setEventListeners();
  }

  setEventListeners() {

    let lastScrollPosition = window.scrollY || document.documentElement.scrollTop;

    window.addEventListener('scroll', () => {
      
      const currentScrollPosition = window.scrollY || document.documentElement.scrollTop;
      const deltaY = currentScrollPosition - lastScrollPosition;
      
      if (deltaY < 0) {
        if(!this.visible) {
          this.classList.add('visible');
          this.visible = true;
        }
      } else if (deltaY > 0 && currentScrollPosition > 50) {
        if(this.visible) {
          this.classList.remove('visible');
          this.visible = false;
        }
      }

      lastScrollPosition = currentScrollPosition;

    });

  }

}

customElements.define('bottom-cta', BottomCTA);

/* ==================== GAME NAVIGATION ==================== */

class GameNavigation extends HTMLElement {

  constructor() {
    super();
  }

}

customElements.define('game-navigation', GameNavigation);

/* ==================== FLOATING IMAGE ==================== */

class FloatingImage extends HTMLElement {
  
  constructor() {
    super();
    this.mobile = false;
    this.init();
  }
  
  init() {
    
    if(window.innerWidth < 640) this.mobile = true;

    if(this.mobile) {

      this.x = parseInt(this.dataset.md_x) | false;
      this.y = parseInt(this.dataset.md_y) | false;
      this.rotation = parseInt(this.dataset.md_rotation) | false;

      if(this.x || this.y || this.rotation) this.setMobilePositions();

    } else {

      this.x = parseInt(this.dataset.x) | 0;
      this.x_to = parseInt(this.dataset.x_to) | false;
  
      this.y = parseInt(this.dataset.y) | false;
      this.y_to = parseInt(this.dataset.y_to) | this.y - 200;
    
      this.rotation = parseInt(this.dataset.rotation) | false;
      this.rotation_to = parseInt(this.dataset.rotation_to) | 0;
      
      this.setScrollTrigger(); 

    }

  }

  setMobilePositions() {

    this.classList.add('mobile');

    const timeline = gsap.timeline();
    timeline.set(this, { x: this.x, y: this.y, rotate: this.rotation });
    timeline.fromTo(this, { opacity: 0 }, { opacity: 1, duration: .5, delay: 1 });

  }

  setScrollTrigger() {

    const timeline = gsap.timeline();
    timeline.set(this, { x: this.x, y: this.y, rotate: this.rotation });
    if(this.x_to) timeline.to(this, { x: this.x_to, duration: 1, ease: 'none' }, 0);
    if(this.y_to) timeline.to(this, { y: this.y_to, duration: 1, ease: 'none' }, 0);
    if(this.rotation_to) timeline.to(this, { rotate: this.rotation_to, duration: 1, ease: 'none' }, 0);
    
    ScrollTrigger.create({
      animation: timeline,
      trigger: this,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true
    });

  }
  
}

customElements.define('floating-image', FloatingImage);

/* ==================== SECTION : GAME CTA ==================== */

class GameCTAIllu extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }
  
  init() {
    if(window.innerWidth > 640) this.setScrollAnimation();
    // else this.setMobileScrollAnimation();
    this.setScrollTrigger();
  }

  setScrollAnimation() {

    this.timeline = gsap.timeline();
    this.timeline.fromTo(this.querySelector('.box'), { y: 100, rotateX: 6, rotateY: -40 }, { y: 0, rotateX: 18, rotateY: -25, duration: 1, ease: 'none' }, 0);
    this.timeline.fromTo(this.querySelector('.card.left'), { rotate: 0, x: -125, y: 300 }, { rotate: -10, x: -200, y: 150, duration: 1, ease: 'none' }, 0);
    this.timeline.fromTo(this.querySelector('.card.right'), { rotate: 0, x: 100, y: 400 }, { rotate: 8, x: 150, y: 125, duration: 1, ease: 'none' }, 0);

  }

  setMobileScrollAnimation() {

    this.timeline = gsap.timeline();
    this.timeline.set(this.querySelector('.card.left'), { x: -125 });
    this.timeline.set(this.querySelector('.card.right'), { x: 125 });
    this.timeline.fromTo(this.querySelector('.box'), { y: 50 }, { y: -100, duration: 1, ease: 'none' }, 0);
    this.timeline.fromTo(this.querySelector('.card.left'), { rotate: 0, y: 100 }, { rotate: -10, y: 50, duration: 1, ease: 'none' }, 0);
    this.timeline.fromTo(this.querySelector('.card.right'), { rotate: 0, y: -100 }, { rotate: 10, y: -50, duration: 1, ease: 'none' }, 0);

  }

  setScrollTrigger() {
    
    ScrollTrigger.create({
      animation: this.timeline,
      trigger: this,
      start: 'top bottom',
      end: 'top top',
      scrub: true
    });

  }
  
}

customElements.define('game-cta-illu', GameCTAIllu);

/* ==================== STORE RATING ==================== */

class StoreRating extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init() {
    this.index = parseInt(this.dataset.index);
    this.delay = (this.index - 1) * .1;
    this.stars = this.querySelectorAll('.star');
    if(window.innerWidth > 640) this.setScrollAnimation();
  }

  setScrollAnimation() {

    const timeline = gsap.timeline({ paused: true });

    timeline.fromTo(this.querySelector('.logo'), { opacity: 0, }, { opacity: 1, duration: 1, ease: 'none', delay: this.delay }, 0);
    timeline.fromTo(this.stars, { opacity: 0, }, { opacity: 1, duration: 1, ease: 'none', stagger: .01, delay: this.delay }, 0);
    timeline.fromTo(this.querySelector('p'), { opacity: 0, }, { opacity: 1, duration: 1, ease: 'none', delay: this.delay + .5 }, 0);

    ScrollTrigger.create({
      trigger: this,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true,
      onEnter: () => {
        timeline.play();
      }
    });

  }

}

customElements.define('store-rating', StoreRating);

/* ==================== SECTION IMAGE AND TEXT ==================== */

class ImageAndText extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init() {
    this.image = this.querySelector('.image img');
    this.setSizes();
    if(window.innerWidth > 640) this.setImageScrollTrigger();
  }

  setSizes() {
    this.image.style.height = this.image.offsetHeight + 200 + 'px';
  }

  setImageScrollTrigger() {

    const timeline = gsap.timeline();

    timeline.fromTo(this.image, { y: -100 }, { y: 100, duration: 1, ease: Power0.easeNone }, 0);

    ScrollTrigger.create({
      trigger: this,
      animation: timeline,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true
    });

  }

}

customElements.define('image-and-text', ImageAndText);

/* ==================== SECTION : FEATURE ==================== */

class FeatureItem extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }
  
  init() {
    this.setEventListeners();
  }

  setEventListeners() {
    document.addEventListener('mousemove', e => {
      this.updateMousePosition(e);
    })
  }

  updateMousePosition(e) {

    const rect = this.getBoundingClientRect();

    this.x = Math.round(e.clientX - rect.left);
    this.y = Math.round(e.clientY - rect.top);

    this.style.setProperty('--cursor-x', `${this.x}px`);
    this.style.setProperty('--cursor-y', `${this.y}px`);
    
  }
  
}

customElements.define('feature-item', FeatureItem);

class FeatureCard extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }
  
  init() {
    this.rotate = parseInt(this.dataset.rotate);
    this.from = parseInt(this.dataset.from);
    if(this.rotate != undefined) this.setScrollTrigger();
  }

  setScrollTrigger() {

    const timeline = gsap.timeline();
    // timeline.to(this, { rotate: this.rotate, duration: 1, ease: 'power2.inOut' }, 0);
    // timeline.from(this, { x: this.from, opacity: 0, duration: 1, ease: 'power2.inOut' }, 0);
    timeline.set(this, { rotate: this.rotate });
    timeline.from(this, { opacity: 0, duration: 1, ease: 'power2.inOut' }, 0);
    
    // ScrollTrigger.create({
    //   trigger: this,
    //   start: '-500px',
    //   onEnter: () => {
    //     timeline.play();
    //   }
    // });

  }
  
}

customElements.define('feature-card', FeatureCard);

/* ==================== SPLIT TEXT ==================== */

class SplitText extends HTMLElement {
  
  constructor() {
    super();
    this.spans = [];
    this.speed = this.dataset.speed || .01;
    this.delay = this.dataset.delay || 0;
    this.class = this.dataset.class || null;
    this.init();
  }

  init() {
    this.split();
    if(window.innerWidth > 640) this.setScrollTrigger();
  }

  split() {
  
    const words = this.textContent.split(' ');
    this.innerHTML = '';

    words.forEach((word) => {

      word.split('').forEach((letter, i) => {
        const span = document.createElement('span');
        if(this.class) span.classList.add(this.class);
        span.textContent = letter;
        this.appendChild(span);
        this.spans.push(span);
      });

      // Add a space between words
      const space = document.createTextNode(' ');
      this.appendChild(space);

    });

  }

  setScrollTrigger() {

    const timeline = gsap.timeline({ paused: true });
    timeline.fromTo(this.spans, { opacity: 0 }, { opacity: 1, duration: 1, ease: 'power2.inOut', stagger: this.speed, delay: this.delay });
    
    ScrollTrigger.create({
      trigger: this,
      start: `${- size.height}px`,
      onEnter: () => {
        timeline.play();
      }
    });

  }

}

customElements.define('split-text', SplitText);

/* ==================== UP TITLE ==================== */

class UpTitle extends HTMLElement {

  constructor() {
    super();
    this.reflex;
    this.init();
  }

  init() {
    this.setReflect();
    this.setReflectAnimation();
  }

  setReflect() {
    this.reflect = document.createElement('div');
    this.reflect.classList.add('reflect');
    this.appendChild(this.reflect);
  }

  setReflectAnimation() {

    const timeline = gsap.timeline({ paused: true });
    timeline.fromTo(this.reflect, { x: '-100%' }, { x: '100%', duration: 1, ease: 'power2.inOut' });

    ScrollTrigger.create({
      trigger: this,
      start: '-500px',
      onEnter: () => {
        timeline.play();
      }
    });
    
  }

}

customElements.define('up-title', UpTitle);

// ==================== SECTION : FAQ ==================== //

class FAQButton extends HTMLElement {
  
  constructor() {
    super();
    this.setEvents();
  }

  setEvents() {
    this.addEventListener('click', () => {
      for(let question of document.querySelectorAll('.section.faq .hidden')) {
        question.classList.remove('hidden');
      }
      this.classList.add('hidden');
    });
  }

}

customElements.define('faq-button', FAQButton);

class FAQQuestions extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init() {
    this.setScrollAnimation();
  }

  setScrollAnimation() {

    const timeline = gsap.timeline({ paused: true });
    timeline.fromTo(this.querySelectorAll('faq-question'), { opacity: 0 }, { opacity: 1, duration: 1, ease: 'power2.inOut', stagger: .1 });
    
    ScrollTrigger.create({
      trigger: this,
      start: `${- size.height}px`,
      onEnter: () => {
        timeline.play();
      }
    });

  }

}

customElements.define('faq-questions', FAQQuestions);

class FAQQuestion extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setEvents();
  }

  setEvents() {
    this.addEventListener('click', () => {
      this.classList.toggle('active');
    });
  }

}

customElements.define('faq-question', FAQQuestion);

// ==================== FEATURES LIST ==================== //

class FeaturesList extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init() {
    if(window.innerWidth > 640) this.setScrollAnimation();
  }

  setScrollAnimation() {

    const timeline = gsap.timeline({ paused: true });
    timeline.fromTo(this.querySelectorAll('.features-list-item'), { opacity: 0 }, { opacity: 1, duration: 1, ease: 'power2.inOut', stagger: .1 });
    
    ScrollTrigger.create({
      trigger: this,
      start: `${- size.height}px`,
      onEnter: () => {
        timeline.play();
      }
    });

  }
  
}

customElements.define('features-list', FeaturesList);

class CustomSeparator extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init() {
    if(window.innerWidth > 640) this.setScrollAnimation();
  }

  setScrollAnimation() {

    const timeline = gsap.timeline({ paused: true });
    timeline.fromTo(this, { scaleX: .5, opacity: 0 }, { scaleX: 1, opacity: 1, duration: 1, ease: 'power2.inOut' });
    
    ScrollTrigger.create({
      trigger: this,
      start: '-700px',
      onEnter: () => {
        timeline.play();
      }
    });

  }

}

customElements.define('custom-separator', CustomSeparator);

// ==================== SECTION : ACTION CARDS ==================== //

class CardsSlider extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setTiltEffect();
    if(window.innerWidth > 728) this.setScrollAnimation();
    this.setSlider();
  }

  setTiltEffect() {

    VanillaTilt.init(this.querySelectorAll('.card-tilt'), {
      max: 4,
      speed: 400
    });

  }

  setScrollAnimation() {
    
    const timeline = gsap.timeline();
    timeline.fromTo(this.querySelector('.card-wrap-1'), { y: 100 }, { y: -200, duration: 1, ease: 'none' }, 0);
    timeline.fromTo(this.querySelector('.card-wrap-2'), { y: 150 }, { y: -50, duration: 1, ease: 'none' }, 0);
    timeline.fromTo(this.querySelector('.card-wrap-3'), { y: 150 }, { y: -150, duration: 1, ease: 'none' }, 0);
    timeline.fromTo(this.querySelector('.card-wrap-4'), { y: 100 }, { y: 0, duration: 1, ease: 'none' }, 0);
    timeline.fromTo(this.querySelector('.card-wrap-5'), { y: 100 }, { y: -50, duration: 1, ease: 'none' }, 0);
    timeline.fromTo(this.querySelector('.card-wrap-6'), { y: 100 }, { y: -100, duration: 1, ease: 'none' }, 0);

    ScrollTrigger.create({
      trigger: this,
      animation: timeline,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true
    });

  }

  setSlider() {
    
    const slider = new Splide(this, {
      type: 'loop',
      perPage: 5,
      padding: 70,
      gap: 35,
      arrows: true,
      pagination: false,
      autoplay: true,
      autoplay: true,
      interval: 2000,
      breakpoints: {
        400: {
          padding: 90
        },
        480: {
          padding: 130
        },
        640: {
          perPage: 1,
          gap: 20,
          padding: 160
        },
        728: {
          padding: 110
        },
        1024: {
          perPage: 3
        },
        1240: {
          perPage: 4
        }
      }
    });
    slider.mount( );
    
  }

}

customElements.define('cards-slider', CardsSlider);

// ==================== SECTION : SCRATCHING CARDS ==================== //

class ScratchingCard extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setEventsListener();
  }

  setEventsListener() {
    this.addEventListener('mousemove', e => {
      const bubblesHalf = 25;
      const bubbles = document.createElement('span');
      bubbles.style.left = e.offsetX - bubblesHalf + 'px';
      bubbles.style.top = e.offsetY - bubblesHalf + 'px';
      this.appendChild(bubbles);
    });
  }

}

customElements.define('scratching-card', ScratchingCard);

// ==================== SECTION : PARALLAX ==================== //

class ParallaxSection extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }

  init() {
    if(window.innerWidth > 640) {
      this.querySelector('img').style.height = this.querySelector('img').offsetHeight + 400 + 'px';
      this.setScrollAnimation();
    }
  }

  setScrollAnimation() {

    const timeline = gsap.timeline();

    timeline.fromTo(this.querySelector('img'), { scale: 1.5, y: -200 }, { scale: 1, y: 200, duration: 1, ease: Power0.easeNone }, 0);

    ScrollTrigger.create({
      trigger: this,
      animation: timeline,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true
    });
    
  }

}

customElements.define('parallax-section', ParallaxSection);

// ==================== SECTION : TESTIMONIES ==================== //

class TestimoniesSlider extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setSlider();
  }

  setSlider() {
    const slider = new Splide(this, {
      type: 'loop',
      perPage: 2,
      arrows: true,
      pagination: true,
      padding: 100,
      gap: 75,
      autoplay: true,
      interval: 1000,
      breakpoints: {
        640: {
          perPage: 1,
          padding: 60,
          gap: 75
        },
        1024: {
          padding: 50
        }
      }
    });
    slider.mount();
  }

}

customElements.define('testimonies-slider', TestimoniesSlider);

// ==================== IMAGE AND TEXT FEATURES ==================== //

class ImageAndTextFeature extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init() {
    this.setEventListeners();
    this.setScrollAnimation();
  }

  setEventListeners() {
    this.addEventListener('click', () => {
      removeClassNameToCollection('image-and-text-feature', 'active');
      this.classList.add('active');
    });
  }

  setScrollAnimation() {
    
    const timeline = gsap.timeline({ paused: true });
    timeline.fromTo(this, { opacity: 0 }, { opacity: 1, duration: 1, ease: 'power2.inOut' });
    
    ScrollTrigger.create({
      trigger: this,
      start: `${- size.height}px`,
      onEnter: () => {
        timeline.play();
      }
    });

  }

}

customElements.define('image-and-text-feature', ImageAndTextFeature);

// ==================== BLUR BACKGROUND ==================== //

class BlurBackground extends HTMLElement {

  constructor() {
    super();
  }

}

customElements.define('blur-background', BlurBackground);

